import React from 'react';

// Logo Bloomu: devět okvětních lístků vyrůstá z jednoho bodu dole a rozevírá se do vějíře.
// Každý lístek je čočkovitý tvar (špičatý na obou koncích) otočený o svůj úhel — díky tomu
// stačí jeden tvar a lístky drží stejný rukopis. Úhel 0 míří vzhůru, záporný doleva.
// Pořadí v poli je i pořadím vykreslení: krajní lístky vzadu, prostřední navrchu.
const PETALS = [
  // úhel = odklon od svislice (záporný doleva), délka a šířka v jednotkách viewBoxu.
  // Vějíř je záměrně nesouměrný, stejně jako v předloze.
  { angle: -78, length: 54, width: 7.3, fill: '#FBD8DD' },
  { angle: 96, length: 38, width: 5.1, fill: '#DEEBFA' },
  { angle: -50, length: 68, width: 9.2, fill: '#DEEBFA' },
  { angle: 71, length: 54, width: 7.3, fill: '#FBD8DD' },
  { angle: -40, length: 55, width: 7.4, fill: '#FFFFFF' },
  { angle: 37, length: 68, width: 9.2, fill: '#FFFFFF' },
  { angle: -25, length: 80, width: 10.8, fill: '#FBD8DD' },
  { angle: 18, length: 75, width: 10.1, fill: '#FBD8DD' },
  { angle: 4, length: 88, width: 11.9, fill: '#FFFFFF' },
];

// Obrys loga i nápisu. Drží se odstínu z originálu, ne fialové z aplikace.
export const LOGO_INK = '#6B72E8';

const petalPath = (length, width) => {
  const round = (n) => Math.round(n * 10) / 10;
  return `M0 0C${-width} ${round(-length * 0.34)} ${-width} ${round(-length * 0.7)} 0 ${-length}`
    + `C${width} ${round(-length * 0.7)} ${width} ${round(-length * 0.34)} 0 0Z`;
};

export const LotusLogo = ({ size = 40, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`lotus-logo ${className}`}
    role="img"
    aria-label="Bloom"
  >
    <g transform="translate(60 100)" stroke={LOGO_INK} strokeWidth="2.2" strokeLinejoin="round">
      {PETALS.map((petal) => (
        <path
          key={`${petal.angle}-${petal.length}`}
          d={petalPath(petal.length, petal.width)}
          fill={petal.fill}
          transform={`rotate(${petal.angle})`}
        />
      ))}
    </g>
  </svg>
);

// Logo i s nápisem — pro úvodní stránku, přihlášení a intro.
export const BloomWordmark = ({ size = 96, className = '' }) => (
  <div className={`flex flex-col items-center ${className}`}>
    <LotusLogo size={size} />
    <span
      className="font-heading font-bold leading-none"
      style={{ color: LOGO_INK, fontSize: Math.round(size * 0.44), marginTop: Math.round(size * 0.06) }}
    >
      Bloom
    </span>
  </div>
);
